import {Action} from '@ngrx/store';

export const PAGE_STATE_RESET = '[VeranstaltungHomePage] Page State reset';
export const TOGGEL_INFO_KATEGORIE_ACTION = '[VeranstaltungHomePage] Toggle Info Kategorie';
export const TOGGLE_ROLLE = '[VeranstaltungHomePage] Toggle Rolle';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

export class ToggleInfoKategorieAction implements Action {
    readonly type = TOGGEL_INFO_KATEGORIE_ACTION;

    constructor(public infoKategorieId: string) {
    }
}

export class ToggleRolleAction implements Action {
    readonly type = TOGGLE_ROLLE;

    constructor(public rolleId: string) {
    }

}

export type Actions =
    PageStateResetAction
    | ToggleInfoKategorieAction
    | ToggleRolleAction
    ;
